import React, { useRef, useEffect } from 'react';
import cs from 'classnames';
import { useDropdownContext } from './context';
import { Icon } from '../../atoms/Icon/index';
export var DropdownItem = function DropdownItem(props) {
  var _useDropdownContext = useDropdownContext(),
      open = _useDropdownContext.open,
      toggle = _useDropdownContext.toggle,
      itemToggle = _useDropdownContext.itemToggle,
      highlightIndex = _useDropdownContext.highlightIndex,
      menuRef = _useDropdownContext.menuRef;

  var itemRef = useRef(null);

  var scrollToTop = function scrollToTop() {
    if (menuRef.current) {
      var firstItem = menuRef.current.querySelector('button.telia-dropdown-item');

      if (firstItem && itemRef.current && firstItem === itemRef.current) {
        itemRef.current.scrollIntoView({
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
  };

  var scrollActiveIntoView = function scrollActiveIntoView() {
    if (props.index === highlightIndex && itemRef.current) {
      itemRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  };
  /**
   * NB: scrollIntoView is not supported properly in ie11. This currently
   * needs to be handled by the user with a polyfill
   */


  useEffect(function () {
    if (highlightIndex === -1) {
      scrollToTop();
    } else {
      scrollActiveIntoView();
    }
  }, [props.index, highlightIndex, itemRef.current, open]);

  var onClick = function onClick(e) {
    if (props.onClick) {
      e.preventDefault();
      props.onClick(e);
    }

    if (itemToggle) {
      toggle();
    }
  };

  var content = /*#__PURE__*/React.createElement(React.Fragment, null, props.leading ? props.leading : null, props.icon && !props.leading && /*#__PURE__*/React.createElement("div", {
    className: "telia-dropdown-item__icon-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "telia-dropdown-item__icon",
    icon: props.icon
  })), /*#__PURE__*/React.createElement("div", null, props.label ? /*#__PURE__*/React.createElement("div", null, props.label) : null, /*#__PURE__*/React.createElement("div", null, props.children)));

  if (props.divider) {
    return /*#__PURE__*/React.createElement("div", {
      className: "telia-dropdown-item telia-dropdown-item__divider"
    });
  }

  if (props.header && props.centered) {
    return /*#__PURE__*/React.createElement("div", {
      className: "telia-dropdown-item telia-dropdown-item__header--centered"
    }, content);
  }

  if (props.header) {
    return /*#__PURE__*/React.createElement("div", {
      className: "telia-dropdown-item telia-dropdown-item__header"
    }, content);
  }

  var Tag = props.onClick ? 'button' : 'div';
  var isClickable = props.onClick || itemToggle;
  return /*#__PURE__*/React.createElement(Tag, {
    className: cs('telia-dropdown-item', {
      'telia-dropdown-item__centered': props.centered,
      'telia-dropdown-item__active': open && isClickable && props.index === highlightIndex,
      'telia-dropdown-item__clickable': isClickable
    }, props.className),
    ref: function ref(instance) {
      return itemRef.current = instance;
    },
    tabIndex: -1,
    role: isClickable ? props.href ? 'link' : 'button' : undefined,
    onFocus: function onFocus(e) {
      return e.stopPropagation();
    },
    onClick: isClickable ? onClick : undefined
  }, content);
};
export var DropdownSearchItem = function DropdownSearchItem(props) {
  var _useDropdownContext2 = useDropdownContext(),
      open = _useDropdownContext2.open,
      setHighlightIndex = _useDropdownContext2.setHighlightIndex;

  var itemRef = useRef(null);
  useEffect(function () {
    setTimeout(function () {
      if (itemRef.current && open) {
        itemRef.current.focus();
      }
    }, 100);
  }, [open, itemRef.current]);
  return /*#__PURE__*/React.createElement("div", {
    className: "telia-dropdown-item telia-dropdown-item__search"
  }, props.icon ? /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    style: {
      height: '1.5rem',
      width: '1.5rem'
    }
  }) : null, /*#__PURE__*/React.createElement("input", {
    ref: itemRef,
    value: props.value,
    placeholder: props.placeholder,
    onChange: function onChange(e) {
      props.onInputChange(e.target.value);
      setHighlightIndex(0);
    }
  }));
};